/**
 * VIEW OTP — احراز هویت
 */

import { CONFIG }     from '../config.js';
import { escapeHtml } from '../utils.js';

export function showPhoneStep() {
  document.getElementById('otp-step-phone').classList.remove('hidden');
  document.getElementById('otp-step-code').classList.add('hidden');
}

export function showCodeStep(phone) {
  document.getElementById('otp-step-phone').classList.add('hidden');
  document.getElementById('otp-step-code').classList.remove('hidden');
  document.getElementById('otp-code-subtitle').innerHTML =
    `کد ۴ رقمی ارسال شده به <span style="font-weight:bold;color:var(--dark);direction:ltr;display:inline-block;">${escapeHtml(phone)}</span> را وارد نمایید.`;
}

export function startCountdown(sentAt, onExpired) {
  const countdownEl = document.getElementById('otp-countdown');
  const timerBox    = document.getElementById('otp-timer-box');
  const btnResend   = document.getElementById('btn-resend-otp');
  timerBox.classList.remove('hidden');
  btnResend.classList.add('hidden');
  const tick = () => {
    const remaining = CONFIG.OTP_COUNTDOWN_SEC - Math.floor((Date.now() - sentAt) / 1000);
    if (remaining <= 0) {
      timerBox.classList.add('hidden');
      btnResend.classList.remove('hidden');
      onExpired?.();
    } else {
      countdownEl.textContent = remaining.toLocaleString('fa-IR');
    }
  };
  tick();
  return setInterval(tick, 1000);
}

export function clearDigits() {
  document.querySelectorAll('.otp-digit-box').forEach(b => (b.value = ''));
}

export function getCode() {
  let code = '';
  document.querySelectorAll('.otp-digit-box').forEach(b => (code += b.value));
  return code;
}
